import React from "react";
import { Field } from "redux-form";
import { connect } from "react-redux";
import * as actions from "MODULES/companies/actions";
import { form, Form as AppForm } from "MODULES/shared/components/Forms";
import { validator } from "LIB/validate-this";
import * as rules from "LIB/validation/rules";
import { AIRCRAFT_ID } from "APP_ROOT/constants";
import { searchAircrafts } from "MODULES/Aircraft/actions";
import AutoCompleteField from "MODULES/shared/components/Forms/AutoCompleteField/AutoCompleteField";
import { AIRCRAFT } from "MODULES/Lots/constants";

const FORM_NAME = "createCompanyAircraft";

export function Form(props) {
  return (
    <AppForm {...props}>
      <AppForm.Body>
        <Field
          label={AIRCRAFT}
          name={AIRCRAFT_ID}
          component={AutoCompleteField}
          search={searchAircrafts}
          formatItem={result => result.model_number}
        />
      </AppForm.Body>
    </AppForm>
  );
}

export default connect(undefined, dispatch => ({
  onSubmit: data => dispatch(actions.createAircraft(data))
}))(
  form({
    form: FORM_NAME,
    validate: values =>
      validator(values, f => {
        f.validate(AIRCRAFT_ID).satisfies(rules.required);
      })
  })(Form)
);



// WEBPACK FOOTER //
// ./app/modules/companies/components/Detail/Fleets/Form.jsx